import { Box } from "@stenajs-webui/core";
import { FlatButton, stenaInfoCircle } from "@stenajs-webui/elements";
import { Popover } from "@stenajs-webui/tooltip";
import { InfoBoxItem } from "../InfoBoxItem";
import { MultiLegRouteAgreementBox } from "../types";
import { formatDateStringWithLocalTimeZone } from "@/lib/dates/formatters";
interface Props {
  multiLegRouteAgreement: MultiLegRouteAgreementBox;
}

export const MultiLegRouteAgreementInfoPairPopover: React.FC<Props> = ({
  multiLegRouteAgreement,
}) => {
  return (
    <Popover
      placement={"right"}
      disablePadding
      appendTo={document.body}
      trigger={"click"}
      renderTrigger={(props) => (
        <Box width={16}>
          <FlatButton leftIcon={stenaInfoCircle} {...props} />
        </Box>
      )}
    >
      <Box indent={2} spacing={1}>
        <InfoBoxItem
          leftContent={"Name"}
          rightContent={multiLegRouteAgreement.name}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Cur."}
          rightContent={multiLegRouteAgreement.currency.code}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"No."}
          rightContent={multiLegRouteAgreement.agreementNumber}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Created"}
          rightContent={
            formatDateStringWithLocalTimeZone({
              dateString:
                multiLegRouteAgreement.writeHistory?.createdAt?.isoString,
              options: {
                dateStyle: "short",
                timeStyle: "short",
              },
            }) ?? ""
          }
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Created by"}
          rightContent={
            multiLegRouteAgreement.writeHistory?.createdBy?.name || ""
          }
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Modified"}
          rightContent={
            (multiLegRouteAgreement.writeHistory?.modifiedAt?.isoString &&
              formatDateStringWithLocalTimeZone({
                dateString:
                  multiLegRouteAgreement.writeHistory?.modifiedAt?.isoString,
                options: {
                  dateStyle: "short",
                  timeStyle: "short",
                },
              })) ??
            ""
          }
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Modified by"}
          rightContent={
            multiLegRouteAgreement.writeHistory?.modifiedBy?.name || ""
          }
          popoverEnabled
        />
      </Box>
    </Popover>
  );
};
